import p5Types from "p5";
import { Rect } from "../util";
import AsteroidAgent, { Move } from "./AsteroidAgent";

import Network from "../../neat/network";

export default class NeatAgent extends AsteroidAgent {
  private network: Network;

  constructor(rect: Rect, network: Network) {
    super(rect);
    this.network = network;
  }

  public update(asteroidRect: Rect, _: p5Types): Move {
    const result = this.network.predict([
      this.rect.x,
      asteroidRect.x,
      asteroidRect.y,
    ]);

    if (result[0] > result[1] && result[0] > result[2]) {
      return "left";
    } else if (result[1] > result[0] && result[1] > result[2]) {
      return "right";
    } else {
      return "idle";
    }
  }

  public onDie(score: number): void {
    this.network.setFitness(score);
  }
}
